import {
    getAttendanceDeviceData,
    getAttendanceDeviceUuid,
    getAttendancePlatform
} from "./attendance-device-helper";


const AttendanceHelpers = {
    getDeviceData: getAttendanceDeviceData,
    getDeviceUuid: getAttendanceDeviceUuid,
    getPlatform: getAttendancePlatform
};

export {
    getAttendanceDeviceData,
    getAttendanceDeviceUuid,
    getAttendancePlatform
};

export default AttendanceHelpers;
